import { TransformBoolean } from '../../../shared/decorators/transform-boolean.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { ChargeTypeEnum } from '../../../shared/enums/charge-type.enum';
import { PricingPresetRequirementEnum } from '../../../shared/enums/pricing-preset-requirement.enum';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { PricingItemTypeEnum } from '../../../shared/modules/pricing-items/enums/pricing-item-type.enum';

/**
 * Asset pricing item preset DTO for proto API (end customer cannot edit price)
 */
export class AssetPricingItemPresetDto {
  uuid!: string;
  name!: string;
  description?: string;
  type!: PricingItemTypeEnum;
  taxRateType!: TaxRateTypeEnum;
  @TransformFloat()
  unitPrice?: number;
  @TransformInt()
  sortOrder?: number;
  @TransformBoolean()
  hasUnits?: boolean;
  @TransformInt()
  maxUnits?: number;
  chargeType?: ChargeTypeEnum;
  presetRequirement?: PricingPresetRequirementEnum;
  @TransformBoolean()
  isStandardDiscountApplied?: boolean;
}
